import { useState, useEffect } from 'react';
import { SMALL_SCREEN_BREAKPOINT } from '../../../../utils/constants';
import { debounce } from 'lodash';

export const useViewportWidth = () => {
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = debounce(() => {
      setViewportWidth(window.innerWidth);
    }, 300);

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      handleResize.cancel();
    };
  }, []);

  return {
    viewportWidth,
    isMobile: viewportWidth <= SMALL_SCREEN_BREAKPOINT,
    isDesktop: viewportWidth > SMALL_SCREEN_BREAKPOINT,
  };
};

export default useViewportWidth;
